module.exports = __webpack_public_path__ + "static/media/athleadhq-logo.91f3b619.png";